import reactCSS from "reactcss";

const logoPositions = reactCSS({
  'default': {
    tank1: {
      width: '32%',
      top: '30%',
      left: '36%',
    },
    5033: {
      width: '32%',
      top: '35%',
      left: '35%',
    },
    6021: {
      top: '28%',
      left: '33%',
    },
    8070: {
      top: '30%',
      left: '32%',
    },
    9300: {
      width: '37%',
      left: '33%',
    }
  },
});

export default logoPositions;